import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { getPaddingClasses } from '../../utils/padding.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "container--p-none": "web_ui__Container__container--p-none",
  "container--pt-none": "web_ui__Container__container--pt-none",
  "container--pr-none": "web_ui__Container__container--pr-none",
  "container--pb-none": "web_ui__Container__container--pb-none",
  "container--pl-none": "web_ui__Container__container--pl-none",
  "container--px-none": "web_ui__Container__container--px-none",
  "container--py-none": "web_ui__Container__container--py-none",
  "container--p-x-small": "web_ui__Container__container--p-x-small",
  "container--pt-x-small": "web_ui__Container__container--pt-x-small",
  "container--pr-x-small": "web_ui__Container__container--pr-x-small",
  "container--pb-x-small": "web_ui__Container__container--pb-x-small",
  "container--pl-x-small": "web_ui__Container__container--pl-x-small",
  "container--px-x-small": "web_ui__Container__container--px-x-small",
  "container--py-x-small": "web_ui__Container__container--py-x-small",
  "container--p-small": "web_ui__Container__container--p-small",
  "container--pt-small": "web_ui__Container__container--pt-small",
  "container--pr-small": "web_ui__Container__container--pr-small",
  "container--pb-small": "web_ui__Container__container--pb-small",
  "container--pl-small": "web_ui__Container__container--pl-small",
  "container--px-small": "web_ui__Container__container--px-small",
  "container--py-small": "web_ui__Container__container--py-small",
  "container--p-regular": "web_ui__Container__container--p-regular",
  "container--pt-regular": "web_ui__Container__container--pt-regular",
  "container--pr-regular": "web_ui__Container__container--pr-regular",
  "container--pb-regular": "web_ui__Container__container--pb-regular",
  "container--pl-regular": "web_ui__Container__container--pl-regular",
  "container--px-regular": "web_ui__Container__container--px-regular",
  "container--py-regular": "web_ui__Container__container--py-regular",
  "container--p-medium": "web_ui__Container__container--p-medium",
  "container--pt-medium": "web_ui__Container__container--pt-medium",
  "container--pr-medium": "web_ui__Container__container--pr-medium",
  "container--pb-medium": "web_ui__Container__container--pb-medium",
  "container--pl-medium": "web_ui__Container__container--pl-medium",
  "container--px-medium": "web_ui__Container__container--px-medium",
  "container--py-medium": "web_ui__Container__container--py-medium",
  "container--p-large": "web_ui__Container__container--p-large",
  "container--pt-large": "web_ui__Container__container--pt-large",
  "container--pr-large": "web_ui__Container__container--pr-large",
  "container--pb-large": "web_ui__Container__container--pb-large",
  "container--pl-large": "web_ui__Container__container--pl-large",
  "container--px-large": "web_ui__Container__container--px-large",
  "container--py-large": "web_ui__Container__container--py-large",
  "container--p-larger": "web_ui__Container__container--p-larger",
  "container--pt-larger": "web_ui__Container__container--pt-larger",
  "container--pr-larger": "web_ui__Container__container--pr-larger",
  "container--pb-larger": "web_ui__Container__container--pb-larger",
  "container--pl-larger": "web_ui__Container__container--pl-larger",
  "container--px-larger": "web_ui__Container__container--px-larger",
  "container--py-larger": "web_ui__Container__container--py-larger",
  "container--p-x-large": "web_ui__Container__container--p-x-large",
  "container--pt-x-large": "web_ui__Container__container--pt-x-large",
  "container--pr-x-large": "web_ui__Container__container--pr-x-large",
  "container--pb-x-large": "web_ui__Container__container--pb-x-large",
  "container--pl-x-large": "web_ui__Container__container--pl-x-large",
  "container--px-x-large": "web_ui__Container__container--px-x-large",
  "container--py-x-large": "web_ui__Container__container--py-x-large",
  "container--p-x-larger": "web_ui__Container__container--p-x-larger",
  "container--pt-x-larger": "web_ui__Container__container--pt-x-larger",
  "container--pr-x-larger": "web_ui__Container__container--pr-x-larger",
  "container--pb-x-larger": "web_ui__Container__container--pb-x-larger",
  "container--pl-x-larger": "web_ui__Container__container--pl-x-larger",
  "container--px-x-larger": "web_ui__Container__container--px-x-larger",
  "container--py-x-larger": "web_ui__Container__container--py-x-larger",
  "container--p-x2-large": "web_ui__Container__container--p-x2-large",
  "container--pt-x2-large": "web_ui__Container__container--pt-x2-large",
  "container--pr-x2-large": "web_ui__Container__container--pr-x2-large",
  "container--pb-x2-large": "web_ui__Container__container--pb-x2-large",
  "container--pl-x2-large": "web_ui__Container__container--pl-x2-large",
  "container--px-x2-large": "web_ui__Container__container--px-x2-large",
  "container--py-x2-large": "web_ui__Container__container--py-x2-large",
  "width-content": "web_ui__Container__width-content",
  "width-wide": "web_ui__Container__width-wide",
  "container": "web_ui__Container__container",
  "styling-narrow": "web_ui__Container__styling-narrow",
  "styling-tight": "web_ui__Container__styling-tight",
  "styling-wide": "web_ui__Container__styling-wide"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Narrow"] = "narrow";
  Styling["Tight"] = "tight";
  Styling["Wide"] = "wide";
  return Styling;
}({});
var Width = /*#__PURE__*/function (Width) {
  Width["Content"] = "content";
  Width["Wide"] = "wide";
  return Width;
}({});
var cssClasses = classNames.bind(styles);
var Container = function Container(_ref) {
  var styling = _ref.styling,
    width = _ref.width,
    children = _ref.children,
    testId = _ref.testId,
    padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingX = _ref.paddingHorizontal,
    paddingY = _ref.paddingVertical;
  var paddingClass = getPaddingClasses(styles, 'container', {
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingX,
    paddingY: paddingY
  });
  var hasPaddingProps = !!(padding || paddingTop || paddingRight || paddingBottom || paddingLeft || paddingX || paddingY);
  var shouldIncludeContainerClass = !hasPaddingProps;
  var shouldApplyStyling = !hasPaddingProps && !!styling;
  var containerClass = cssClasses(shouldIncludeContainerClass && 'container', paddingClass, _defineProperty(_defineProperty({}, "styling-".concat(styling || ''), shouldApplyStyling), "width-".concat(width || ''), !!width));
  return /*#__PURE__*/jsx("div", {
    className: containerClass,
    "data-testid": testId,
    children: children
  });
};
Container.Styling = Styling;
Container.Width = Width;

export { Styling, Width, Container as default };
//# sourceMappingURL=Container.js.map
